import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import DiscountService from '../../../Services/QRCodeServices/DiscountService/DiscountService';

const StatusToggleModal = ({ isOpen, toggle, discount, refreshDiscounts }) => {
  const [isActive, setIsActive] = useState(discount?.isActive || false); 
  const [loading, setLoading] = useState(false); 

  const handleToggleStatus = async () => {
    try {
      setLoading(true);
      await DiscountService.toggleStatus(discount.id, !isActive);
      setIsActive(!isActive);
      refreshDiscounts();
      toggle();
    } catch (error) {
      console.error('Error toggling discount status:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Change Discount Status</ModalHeader>
      <ModalBody>
        <p>
          Are you sure you want to change the status of <strong>{discount?.title}</strong> to{' '}
          <strong>{isActive ? 'Inactive' : 'Active'}</strong>?
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
        <Button color={isActive ? 'danger' : 'success'} onClick={handleToggleStatus} disabled={loading}>
          {loading ? 'Updating...' : isActive ? 'Set Inactive' : 'Set Active'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StatusToggleModal;